import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Clock } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Backend'e form gönderme işlemi
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 3000);
  };

  return (
    <div className="min-h-screen pt-44 pb-16">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6" data-testid="contact-title">
            İletişim
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bizimle iletişime geçmekten çekinmeyin. Size yardımcı olmaktan mutluluk duyarız.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {/* Contact Info Cards */}
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all">
            <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
              <Phone className="w-8 h-8 text-junto-red" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Telefon</h3>
            <p className="text-gray-600 mb-2">Bizi arayın</p>
            <a href="tel:+905533812134" className="text-junto-red font-semibold hover:underline">
              0 (553) 381 21 34
            </a>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all">
            <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
              <Mail className="w-8 h-8 text-junto-red" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">E-posta</h3>
            <p className="text-gray-600 mb-2">Bize yazın</p>
            <a href="mailto:mehmet@juntokahve.com" className="text-junto-red font-semibold hover:underline">
              mehmet@juntokahve.com
            </a>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all">
            <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
              <MapPin className="w-8 h-8 text-junto-red" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Adresler</h3>
            <p className="text-gray-600 mb-3">Bizi ziyaret edin</p>
            <div className="space-y-3">
              <div>
                <p className="text-sm font-semibold text-junto-red">İstanbul</p>
                <p className="text-gray-700 text-sm">
                  Metropol İstanbul 2C/374<br />
                  Ataşehir / İSTANBUL
                </p>
              </div>
              <div>
                <p className="text-sm font-semibold text-junto-red">Karabük</p>
                <p className="text-gray-700 text-sm">
                  Barış Mah. Özemek Sanayi Sitesi No:8<br />
                  Safranbolu / KARABÜK
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Bize Mesaj Gönderin
            </h2>

            {submitted && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-6 py-4 rounded-lg mb-6 fade-in">
                ✅ Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
              </div>
            )}

            <form onSubmit={handleSubmit} data-testid="contact-form">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Adınız Soyadınız *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-junto-red focus:outline-none transition-all"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-junto-red focus:outline-none transition-all"
                    placeholder="ornek@email.com"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Konu *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-junto-red focus:outline-none transition-all"
                  placeholder="Mesajınızın konusu"
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mesajınız *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-junto-red focus:outline-none transition-all"
                  placeholder="Mesajınızı buraya yazın..."
                />
              </div>

              <button
                type="submit"
                className="w-full btn-primary bg-gradient-to-r from-junto-red to-junto-red-dark hover:from-junto-red-dark hover:to-junto-red-light text-white font-bold py-4 px-8 rounded-xl flex items-center justify-center space-x-3 transition-all"
                data-testid="submit-contact-btn"
              >
                <Send className="w-5 h-5" />
                <span>Mesajı Gönder</span>
              </button>
            </form>
          </div>

          {/* Working Hours */}
          <div className="bg-gray-50 rounded-xl p-6 mt-8">
            <div className="flex items-center justify-center space-x-3 text-gray-700">
              <Clock className="w-6 h-6 text-junto-red" />
              <div>
                <p className="font-semibold">Çalışma Saatleri</p>
                <p className="text-sm">Pazartesi - Cuma: 09:00 - 18:00</p>
                <p className="text-sm">Cumartesi: 10:00 - 16:00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;